module.exports = __webpack_public_path__ + "static/img/tab-one.174f8f2d.png";